import {
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableBody,
} from "@material-ui/core";
// import classes from "*.module.css";
import React, { FunctionComponent } from "react";
import { financialItemStyles } from "./financialItemStyle";
import TableContainer from "@material-ui/core/TableContainer";
type DiscountDataProps = {
  discountDetails: Array<object>;
};

export const DiscountSummary: FunctionComponent<DiscountDataProps> = (discountDetails: {
  [key: string]: any;
}) => {
  const classes = financialItemStyles();
  const sum =
    parseFloat(discountDetails.discountDetails.discount_amt_total) +
    parseFloat(discountDetails.discountDetails.dicount_percentage_total) +
    parseFloat(
      discountDetails.discountDetails.total_round_off === undefined
        ? 0.0
        : discountDetails.discountDetails.total_round_off
    );
  // parseFloat(discountDetails.discountDetails.giftVoucher) +
  // parseFloat(discountDetails.discountDetails.loyalityPoint===undefined?0.00:discountDetails.discountDetails.loyalityPoint);

  return (
    <Grid container>
      <Grid item xs={12}>
        <TableContainer>
          <Table
            className={classes.table}
            size="small"
            aria-label="a dense table"
          >
            <TableHead className={classes.tableRow}>
              <TableRow style={{ height: "3em" }}>
                <TableCell align="left" className={classes.headColor}>
                  Type
                </TableCell>
                <TableCell align="right" className={classes.headColor}>
                  Discount Amount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align="left" className={classes.columnWeight}>
                  Discount Amount{" "}
                </TableCell>
                <TableCell align="right" className={classes.columnWeight}>
                  {discountDetails.discountDetails.discount_amt_total}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left" className={classes.columnWeight}>
                  Discount Percentage{" "}
                </TableCell>
                <TableCell align="right" className={classes.columnWeight}>
                  {discountDetails.discountDetails.dicount_percentage_total}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left" className={classes.columnWeight}>
                  Round Off{" "}
                </TableCell>
                <TableCell align="right" className={classes.columnWeight}>
                  {discountDetails.discountDetails.total_round_off === undefined
                    ? 0.0
                    : discountDetails.discountDetails.total_round_off}
                </TableCell>
              </TableRow>
              {/* <TableRow>
                <TableCell align="left" className={classes.columnWeight}>
                  Gift Voucher{" "}
                </TableCell>
                <TableCell align="right" className={classes.columnWeight}>
               { discountDetails.discountDetails.giftVoucher}
                </TableCell>
              </TableRow> */}
              {/* <TableRow>
                <TableCell align="left" className={classes.columnWeight}>
                  Loyalty Coupons{" "}
                </TableCell>
                <TableCell align="right" className={classes.columnWeight}>
                { discountDetails.discountDetails.loyalityPoint===undefined?0.00:discountDetails.discountDetails.loyalityPoint}
                </TableCell>
              </TableRow> */}
              <TableRow style={{ height: "3em" }}>
                <TableCell align="left" className={classes.totalCellStyle}>
                  <Typography className={classes.total}>Total</Typography>
                </TableCell>
                {/* <TableCell align="left" className={classes.middleTotalcell} /> */}
                <TableCell align="right" className={classes.totalValueCell}>
                  <Typography className={classes.value}>
                    {discountDetails.discountDetails.disc_total}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      {/* <Grid item xs={12}>
        <Grid container>
          <Grid item xs={6}>
            <Typography className={classes.total}>Total</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography className={classes.value}>{sum}</Typography>
          </Grid>
        </Grid>
      </Grid> */}
    </Grid>
  );
};
